const aeJSON = {
  'Accent Sidebar': 'لهجة الشريط الجانبي',
  'Accent Header': 'رأس تشكيل'
};

export default aeJSON;
